/**
 * Favorites Event Emitter
 * 
 * A simple pub/sub system to sync favorite status between
 * the My Favorites dropdown and the Sidebar menu items.
 */

class FavoritesEventEmitter {
  constructor() {
    this.listeners = {};
  }

  /**
   * Subscribe to favorite changes
   * @param {string} event - Event name ('favoriteRemoved' or 'favoriteAdded')
   * @param {function} callback - Callback function (receives screen_id)
   * @returns {function} Unsubscribe function
   */
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    // Return unsubscribe function
    return () => {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    };
  }

  /**
   * Emit an event to all subscribers
   * @param {string} event - Event name
   * @param {any} data - Data to pass to callbacks (typically screen_id)
   */
  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }

  /**
   * Remove a favorite - emits 'favoriteRemoved' event
   * @param {number} screenId - The screen_id that was removed
   */
  removeFavorite(screenId) {
    this.emit('favoriteRemoved', screenId);
  }

  /**
   * Add a favorite - emits 'favoriteAdded' event
   * @param {number} screenId - The screen_id that was added
   */
  addFavorite(screenId) {
    this.emit('favoriteAdded', screenId);
  }
}

// Create a singleton instance
const favoritesEvents = new FavoritesEventEmitter();

export default favoritesEvents;